import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { getOrderVouchers, getOrderTotalPrice } from 'Store/Order/selectors';
import OrderVoucherSummary from './OrderVoucherSummary';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';

interface IPropsInternal {
  orderVouchers: Julius.Website.OrderItemViewModel[];
  totalPrice: number;
}

type Props = IPropsInternal;

class OrderVoucherSummaryContainer extends React.PureComponent<Props> {
  render() {

    const { orderVouchers, totalPrice } = this.props;

    if (!orderVouchers || !orderVouchers.length) {
      return null;
    }

    return (
      <WrapperBox>
        <OrderVoucherSummary 
          orderVouchers={ orderVouchers }
          totalPrice={ totalPrice }
        />
      </WrapperBox>
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    orderVouchers: getOrderVouchers(state),
    totalPrice: getOrderTotalPrice(state),
  };
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, null),
)(OrderVoucherSummaryContainer);


// WEBPACK FOOTER //
// ./src/components/OrderVoucherSummary/OrderVoucherSummaryContainer.tsx